import { SHOW_ERROR, HIDE_ERROR } from "../../constants/action-types";

export const showErrorMsg = (dispatch) => {
  dispatch({ type: SHOW_ERROR });
};

export const hideErrorMsg = (dispatch) => {
  dispatch({ type: HIDE_ERROR });
};
